import { Base2Presenter } from "core/presenter";
import { CompanyRepository } from "core/repository";

export default class CompanyViewPresenter extends Base2Presenter {
  initialState() {
    return {
      company: null,
      loading: true,
      error: false,
      currentUser: {}
    };
  }

  // FIXME: How to I18n?
  static MineCompanyUuid = "minha-empresa";

  async onStart() {
    let companyUuid = this.routeParams.companyUuid;
    const currentUser = await this.mRuntime.get("currentUser");

    if (companyUuid === CompanyViewPresenter.MineCompanyUuid) {
      companyUuid = currentUser.company_uuid;
    }

    this.enqueue({ currentUser });

    this.loadCompany(companyUuid);
  }

  async loadCompany(uuid) {
    this.enqueue({ loading: true, error: false });

    const companyResult = await CompanyRepository.getOnline(uuid);

    if (companyResult.success) {
      this.enqueue({ company: companyResult.data });
    } else {
      this.enqueue({
        error:
          "Não conseguimos carregar esta empresa! Tente novamente em alguns minutos."
      });

      await this.sendNotification({
        type: "error",
        title: "Oops...",
        content: this.viewModel.error
      });
    }

    this.enqueue({ loading: false });
  }

  onGoBack() {
    this.navigateTo("app.registration.company");
  }

  async onEdit() {
    const vmCompany = this.viewModel.company;
    let routeCompanyUuid = this.routeParams.companyUuid;

    if (this.routeParams.companyUuid === CompanyViewPresenter.MineCompanyUuid) {
      const currentUser = await this.mRuntime.get("currentUser");
      routeCompanyUuid = currentUser.company_uuid;
    }

    const companyUuid = vmCompany ? vmCompany.uuid : routeCompanyUuid;
    this.navigateTo("app.registration.company.edit", { companyUuid });
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/company-view.presenter.js